import AsyncSelect from "react-select/async";
import {useAppDispatch} from "../../../app/store";
import {ADMIN_LANG} from "../../../settings";
import {PlainDetails} from "../../../types/admin";
import {getPlainForms} from "../../../app/slices/admin";

interface Props {
    onChange: (value: PlainDetails, formType: 'start' | 'end') => void;
    initialValue: PlainDetails | null;
    defaultOptions: PlainDetails[] | [];
    formType: 'start' | 'end';
}

const AsyncFormSelect = ({onChange, initialValue, defaultOptions, formType}: Props) => {
    const dispatch = useAppDispatch();

    const loadOptions = (input: string) => {
        return new Promise<PlainDetails[]>((resolve) => {
            if (input.length < 2) {
                return resolve([]);
            }

            dispatch(getPlainForms(input))
                .then((fulfilledAction) => {
                    const data: PlainDetails[] = fulfilledAction.payload.forms;
                    resolve(data);
                })
                .catch(() => resolve([]));
        });
    };

    return (
        <AsyncSelect
            value={initialValue}
            cacheOptions
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            noOptionsMessage={() => ADMIN_LANG.search}
            onChange={(selectedValue) => onChange(selectedValue as PlainDetails, formType)}
            placeholder={ADMIN_LANG.select_form}
            classNamePrefix="react-select"
            className="custom-react-select"
        />
    );
};

export default AsyncFormSelect;